import {
    SAVE,
    ACCOUNT_LIST,
    ACCOUNT_BY_ID,
    SAVE_ACTIVITY,
    ACCOUNT_FILTER,
    PENDING_ACTIVITY,
    EXISTING_SITES,
    SITE_VISIT,
    SITE_VISIT_LIST,
    OPERATION_PROJECT_BY_ID,
    VALET_MOM,
    VALET_MOM_LIST,
    VALET_MOM_BY_ID, EXTERNAL_MOM_LIST,
} from "./type";

const initialState = {
    saveAccountDetails:[],
    accountListDetails:[],
    accountById:[],
    saveActivityRes:[],
    accountFilterContent:[],
    pendingActivity:[],
    existingSiteDetails:[],
    siteVisit:[],
    siteVisitList:[],
    projectById:[],
    createMomResponse:[],
    monListResponse:[],
    momByIdResponse:[],
    externalMomListResponse: []
};

const Valet = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case SAVE:
            return {
                ...state,
                saveAccountDetails: payload,
            };
        case ACCOUNT_LIST:
            return {
                ...state,
                accountListDetails: payload,
            };
        case ACCOUNT_BY_ID:
            return {
                ...state,
                accountById: payload,
            };
        case SAVE_ACTIVITY:
            return {
                ...state,
                saveActivityRes: payload,
            };
        case ACCOUNT_FILTER:
            return {
                ...state,
                accountFilterContent: payload,
            };
        case PENDING_ACTIVITY:
            return {
                ...state,
                pendingActivity: payload,
            };
        case EXISTING_SITES:
            return {
                ...state,
                existingSiteDetails: payload,
            };
        case SITE_VISIT:
            return {
                ...state,
                siteVisit: payload,
            };
        case SITE_VISIT_LIST:
            return {
                ...state,
                siteVisitList: payload,
            };

        case OPERATION_PROJECT_BY_ID:
            return {
                ...state,
                projectById: payload,
            };
        case VALET_MOM:
            return {
                ...state,
                createMomResponse: payload,
            };
        case VALET_MOM_LIST:
            return {
                ...state,
                monListResponse: payload,
            };
        case VALET_MOM_BY_ID:
            return {
                ...state,
                momByIdResponse: payload,
            };
        case EXTERNAL_MOM_LIST:
            return {
                ...state,
                externalMomListResponse: payload,
            };
        default:
            return {...state};
    }
};

export default Valet;